import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showEpisodeContainer } from './redux/episodeContainer.actions';
import { getEpisodesRequested } from './redux/episodeContainer.thunks';
import { PosterEpisode } from './components/PosterEpisode';
import LoadingBlocks from 'components/forms/LoadingBlocks';
import './styles.scss';

export const EpisodeContainer = () => {
  //hooks
  const dispatch = useDispatch();
  const { urlGetEpisode, loadingEpisodes, nameSerie, episodes } = useSelector(
    state => state?.episodeContainer,
  );

  const { search_overCarousel_home_icon_surf } = useSelector(
    state => state?.asset,
  );

  const nameTitle = () => {
    const name = nameSerie || '';
    return name;
  };

  const handleBack = () => {
    // regresa a los carruseles de mis contenidos
    const payload = {
      show: false,
    };
    dispatch(showEpisodeContainer(payload));
  };

  useEffect(() => {
    const url = urlGetEpisode?.replace(/^http:/, "https:");
    dispatch(getEpisodesRequested(url)); // obtiene los episodios
  }, []);

  return (
    <div className="episode-container">
      <div className="episode-container__title">
        <button
          type="button"
          aria-label="back"
          onClick={handleBack}
          className="title__img"
          style={{
            backgroundImage: `url(${search_overCarousel_home_icon_surf})`,
          }}
        />
        <h3 className="title__name-serie">{nameTitle()}</h3>
      </div>

      <section className="episode-container__content">
        {!loadingEpisodes &&
          episodes?.map(episode => (
            <PosterEpisode key={episode?.record_id} contentInfo={episode} />
          ))}
        {loadingEpisodes && <LoadingBlocks />}
      </section>
    </div>
  );
};
